export class ArrayHelper {
    public static toggleSelectedItem(selectedItems: any[], selectItem: any, checkField = '_id') {
        const found = selectedItems.findIndex((e) => e == selectItem[checkField])
        if (found == -1) {
            selectedItems.push(selectItem[checkField])
        } else {
            selectedItems.splice(found, 1)
        }

        return selectedItems
    }
}



// WEBPACK FOOTER //
// ./src/helper/array.helper.ts